export const ninjas = [
    {
        name: "Kuro",
        element: "fire",
    },
    {
        name: "Riki",
        element: "lightning",
    },
    {
        name: "Rin",
        element: "water",
    },
    {
        name: "Souga",
        element: "wind",
    },
    {
        name: "Pepper",
        element: "fire",
    },
    {
        name: "Dragon Flame Kuro",
        element: "fire",
    },
    {
        name: "Moonlit Owl Yoru",
        element: "lightning",
    },
    {
        name: "Snow Dance Rin",
        element: "water",
    }
];

export const sets = {
    fireRelease: {
        name: "Fire Release Set",
        stats: {
            A: {
                fire: 100
            },
            S: {
                fire: 140
            },
            SS: {
                fire: 190 
            }
        }
    },
    lightningRelease: {
        name: "Lightning Release Set",
        stats: {
            A: {
                lightning: 100
            },
            S: {
                lightning: 140
            },
            SS: {
                lightning: 190 
            }
        }
    },
    waterRelease: {
        name: "Water Release Set",
        stats: {
            A: {
                water: 100
            },
            S: {
                water: 140
            },
            SS: {
                water: 190 
            }
        }
    },
    windRelease: {
        name: "Wind Release Set",
        stats: {
            A: {
                wind: 100
            },
            S: {
                wind: 140
            },
            SS: {
                wind: 190 
            }
        }
    },
    blackDragon: {
        name: "Black Dragon Set",
        stats: {
            S: {
                atk: 100
            },
            SS: {
                atk: 130 
            },
            R1: {
                atk: 160
            },
            R2: {
                atk: 200
            },
            R3: {
                atk: 250
            },
            effects: [
                "Kuro gains Triple Jump"
            ]
        }
    },
    thunderLord: {
        name: "Thunderlord Set",
        stats: {
            S: {
                rikiHp: 7
            },
            SS: {
                rikiHp: 6 
            },
            R1: {
                rikiHp: 5
            },
            R2: {
                rikiHp: 4
            },
            R3: {
                rikiHp: 3
            }
        }
    },
    jadeFox: {
        name: "Jade Fox Set",
        stats: {
            S: {
                rinAtk: 200
            },
            SS: {
                rinAtk: 250 
            },
            R1: {
                rinAtk: 300
            },
            R2: {
                rinAtk: 400
            },
            R3: {
                rinAtk: 500
            }
        }
    },
    tengu: {
        name: "Tengu Set",
        stats: {
            S: {
                atk: 140,
                sougaAtk: 211
            },
            SS: {
                atk: 162,
                sougaAtk: 243
            },
            R1: {
                atk: 178,
                sougaAtk: 267
            },
            R2: {
                atk: 194,
                sougaAtk: 292
            },
            R3: {
                atk: 210,
                sougaAtk: 316
            }
        }
    },
    redFlame: {
        name: "Red Flame Set",
        stats: {
            S: {
                pepperAtk: 250
            },
            SS: {
                pepperAtk: 300
            },
            R1: {
                pepperAtk: 350
            },
            R2: {
                pepperAtk: 400
            },
            R3: {
                pepperAtk: 450
            }
        }
    },
    daruma: {
        name: "Daruma Set",
        stats: {
            A: {
                reduceDmg: 8
            },
            S: {
                reduceDmg: 12
            }
        }
    },
    sword: {
        name: "Sword Master",
        stats: {
            B: {
                weapon: 50
            },
            A: {
                weapon: 80
            }
        }
    },
    flameMaster: {
        name: "Flame Master Set",
        stats: {
            S: {
                atk: 277,
                humans: 251 
            },
            SS: {
                atk: 310,
                humans: 285 
            },
            R1: {
                atk: 344,
                humans: 319 
            },
            R2: {
                atk: 382,
                humans: 350 
            },
            R3: {
                atk: 420,
                humans: 380 
            }
        }
    },
    silverMoon: {
        name: "Silver Moon Set",
        stats: {
            S: {
                atk: 80
            },
            SS: {
                atk: 105
            },
            R1: {
                atk: 140
            },
            R2: {
                atk: 175
            },
            R3: {
                atk: 210
            }
        }
    },
    frostyMoon: {
        name: "Frosty Moon Set",
        stats: {
            S: {
                dragon: 251,
                frostStar: 270
            },
            SS: {
                dragon: 285,
                frostStar: 315
            },
            R1: {
                dragon: 319,
                frostStar: 360
            },
            R2: {
                dragon: 350,
                frostStar: 405
            },
            R3: {
                dragon: 380,
                frostStar: 450
            }
        }
    }
};

export const stats = {
    "atk": {
        "prefix": "ATK",
        "suffix": ""
    },
    "beast": {
        "prefix": "When HP is higher than 50%, ATK against Beast Bosses",
        "suffix": ""
    },
    "blossom": {
        "prefix": "Blossom Shuriken ATK",
        "suffix": ""
    },
    "boss": {
        "prefix": "DMG from Boss(es)",
        "suffix": "%"
    },
    "coin": {
        "prefix": "Coin Bonus",
        "suffix": "%"
    },
    "fire": {
        "prefix": "Fire Element ATK",
        "suffix": ""
    },
    "floating": {
        "prefix": "Floating",
        "suffix": ""
    },
    "dragon": {
        "prefix": "DMG against Dragons",
        "suffix": ""
    },
    "fireSouls": {
        "prefix": "Starting Fire Souls",
        "suffix": ""
    },
    "frostStar": {
        "prefix": "+",
        "suffix": "when in Frost Star status"
    },
    "fury": {
        "prefix": "Talent - Fury of Lightning ATK",
        "suffix": ""
    },
    "hp": {
        "prefix": "Max HP",
        "suffix": ""
    },
    "hpPercent": {
        "prefix": "Max HP",
        "suffix": "%"
    },
    "hpRecovery": {
        "prefix": "HP Recovery",
        "suffix": "/s"
    },
    "hpToAtk": {
        "prefix": "Every",
        "suffix": "Max HP converts into 1 ATK"
    },
    "humans": {
        "prefix": "DMG against Humans",
        "suffix": ""
    },
    "lightning": {
        "prefix": "Lightning Element ATK",
        "suffix": ""
    },
    "mecha": {
        "prefix": "DMG against Mecha Bosses",
        "suffix": ""
    },
    "mechaReduce": {
        "prefix": " When HP is lower than 50%, DMG from Mecha Bosses",
        "suffix": "%"
    },
    "minion": {
        "prefix": "DMG from Minions",
        "suffix": "%"
    },
    "minionAndBoss": {
        "prefix": "DMG from Minions and Boss(es)",
        "suffix": "%"
    },
    "ninjutsu": {
        "prefix": "Ninjutsu ATK",
        "suffix": ""
    },
    "ninjutsuEnery": {
        "prefix": "Starting Ninjutsu Energy",
        "suffix": "%"
    },
    "ninjutsuNinja": {
        "prefix": "Ninjutsu ATK",
        "suffix": "(Effective when equipped by same element ninja)"
    },
    "oni": {
        "prefix": "DMG against Oni",
        "suffix": ""
    },
    "pepperAtk": {
        "prefix": "Pepper gains ATK",
        "suffix": "when in possession of 3 Fire Souls"
    },
    "reduceDmg": {
        "prefix": "When HP is below 50%, reduces incoming damage by",
        "suffix": "%"
    },
    "rikiHp": {
        "prefix": "Riki's Max HP converts to ATK at",
        "suffix": ":1"
    },
    "rinAtk": {
        "prefix": "Rin gains",
        "suffix": "bonus ATK at full HP"
    },
    "shuriken": {
        "prefix": "Shuriken Orb ATK",
        "suffix": "Shuriken Orbs turn to element"
    },
    "shurikenNinja": {
        "prefix": "Shuriken Orb ATK",
        "suffix": "(Effective when equipped by same element ninja)"
    },
    "score": {
        "prefix": "Score",
        "suffix": "%"
    },
    "sougaAtk": {
        "prefix": "Souga gains an extra",
        "suffix": "ATK when HP is lower than 60%"
    },
    "soulOfFire": {
        "prefix": "Starting with",
        "suffix": "Stacks of Soul of Fire effect"
    },
    "water": {
        "prefix": "Water Element ATK",
        "suffix": ""
    },
    "weapon": {
        "prefix": "Weapon Skill ATK",
        "suffix": ""
    },
    "weaponCooldown": {
        "prefix": "Weapon Skill Cooldown is",
        "suffix": "%"
    },
    "wind": {
        "prefix": "Wind Element ATK",
        "suffix": ""
    }
};

export const relics = [
    {
        value: "fireRing",
        label: "Fire Ring",
        element: "fire",
        set: "fireRelease",
        stats: {
            A: {
                ninjutsu: 100,
                ninjutsuNinja: 50
            },
            S: {
                ninjutsu: 175,
                ninjutsuNinja: 75
            },
            SS: {
                ninjutsu: 250,
                ninjutsuNinja: 100
            }
        }
    },
    {
        value: "fireShuriken",
        label: "Fire Shuriken",
        element: "fire",
        set: "fireRelease",
        stats: {
            A: {
                shuriken: 105,
                shurikenNinja: 50
            },
            S: {
                shuriken: 135,
                shurikenNinja: 80
            },
            SS: {
                shuriken: 180,
                shurikenNinja: 90
            }
        }
    },
    {
        value: "aoki",
        label: "Aoki's Kiss",
        ninja: "Kuro",
        set: "blackDragon",
        stats: {
            S: {
                minion: -1,
                score: 10
            },
            SS: {
                minion: -2,
                score: 20
            },
            R1: {
                minion: -3,
                score: 25
            },
            R2: {
                minion: -4,
                score: 31
            },
            R3: {
                minion: -5,
                score: 39
            }
        },
        effects: [
            "Dragon Gunfire can destroy Obstacles"
        ]
    },
    {
        value: "horn",
        label: "Dragon Bone Horn",
        ninja: "Kuro",
        set: "blackDragon",
        stats: {
            S: {
                atk: 70,
                hp: 27
            },
            SS: {
                atk: 130,
                hp: 40
            },
            R1: {
                atk: 155,
                hp: 50
            },
            R2: {
                atk: 180,
                hp: 60
            },
            R3: {
                atk: 219,
                hp: 70
            }
        }
    },
    {
        value: "armlets",
        label: "Dragon Fang Armlets",
        ninja: "Kuro",
        set: "blackDragon",
        stats: {
            S: {
                atk: 45,
                dragon: 99
            },
            SS: {
                atk: 80,
                dragon: 188
            },
            R1: {
                atk: 95,
                dragon: 220
            },
            R2: {
                atk: 112,
                dragon: 260
            },
            R3: {
                atk: 132,
                dragon: 301
            }
        }
    },
    {
        value: "lantern",
        label: "Flame Dragon Soul Lantern",
        ninja: "Kuro",
        set: "blackDragon",
        stats: {
            S: {
                fire: 142,
                oni: 133
            },
            SS: {
                fire: 187,
                oni: 184
            },
            R1: {
                fire: 227,
                oni: 228
            },
            R2: {
                fire: 269,
                oni: 274
            },
            R3: {
                fire: 300,
                oni: 311
            }
        }
    },
    {
        value: "scarf",
        label: "Dragon Blood Scarf",
        ninja: "Kuro",
        set: "blackDragon",
        stats: {
            S: {
                score: 24,
                boss: -4
            },
            SS: {
                score: 45,
                boss: -6
            },
            R1: {
                score: 54,
                boss: -7
            },
            R2: {
                score: 70,
                boss: -8
            },
            R3: {
                score: 88,
                boss: -9
            }
        }
    },
    {
        value: "lightningRing",
        label: "Lightning Ring",
        element: "lightning",
        set: "lightningRelease",
        stats: {
            A: {
                ninjutsu: 100,
                ninjutsuNinja: 50
            },
            S: {
                ninjutsu: 175,
                ninjutsuNinja: 75
            },
            SS: {
                ninjutsu: 250,
                ninjutsuNinja: 100
            }
        }
    },
    {
        value: "lightningShuriken",
        label: "Lightning Shuriken",
        element: "lightning",
        set: "lightningRelease",
        stats: {
            A: {
                shuriken: 105,
                shurikenNinja: 50
            },
            S: {
                shuriken: 135,
                shurikenNinja: 80
            },
            SS: {
                shuriken: 180,
                shurikenNinja: 90
            }
        }
    },
    {
        value: "electroShoes",
        label: "Super ElectroMagnetic Shoes",
        ninja: "Riki",
        set: "thunderLord",
        stats: {
            S: {
                hp: 0,
                floating: 0
            },
            SS: {
                hp: 30,
                floating: 0.6
            },
            R1: {
                hp: 60,
                floating: 1.1
            },
            R2: {
                hp: 90,
                floating: 1.1
            },
            R3: {
                hp: 120,
                floating: 1.6
            }
        }
    },
    {
        value: "vajra",
        label: "Thunder Vajra",
        ninja: "Riki",
        set: "thunderLord",
        stats: {
            S: {
                lightning: 68,
                hpToAtk: 7
            },
            SS: {
                lightning: 108,
                hpToAtk: 6
            },
            R1: {
                lightning: 127,
                hpToAtk: 6
            },
            R2: {
                lightning: 147,
                hpToAtk: 5
            },
            R3: {
                lightning: 169,
                hpToAtk: 4
            }
        }
    },
    {
        value: "supercharger",
        label: "Super Charger",
        ninja: "Riki",
        set: "thunderLord",
        stats: {
            S: {
                hp: 45,
                atk: 45
            },
            SS: {
                hp: 70,
                atk: 80
            },
            R1: {
                hp: 80,
                atk: 95
            },
            R2: {
                hp: 96,
                atk: 112
            },
            R3: {
                hp: 115,
                atk: 132
            }
        }
    },
    {
        value: "ironHelmet",
        label: "Mighty Iron Helmet",
        ninja: "Riki",
        set: "thunderLord",
        stats: {
            S: {
                fury: 394,
                hp: 43
            },
            SS: {
                fury: 614,
                hp: 65
            },
            R1: {
                fury: 711,
                hp: 76
            },
            R2: {
                fury: 846,
                hp: 87
            },
            R3: {
                fury: 1000,
                hp: 105
            }
        }
    },
    {
        value: "gourd",
        label: "Wine Master's Gourd",
        ninja: "Riki",
        set: "thunderLord",
        stats: {
            S: {
                score: 24,
                minion: -5
            },
            SS: {
                score: 45,
                minion: -6
            },
            R1: {
                score: 54,
                minion: -7
            },
            R2: {
                score: 70,
                minion: -8
            },
            R3: {
                score: 88,
                minion: -9
            }
        }
    },
    {
        value: "waterRing",
        label: "Water Ring",
        element: "water",
        set: "waterRelease",
        stats: {
            A: {
                ninjutsu: 100,
                ninjutsuNinja: 50
            },
            S: {
                ninjutsu: 175,
                ninjutsuNinja: 75
            },
            SS: {
                ninjutsu: 250,
                ninjutsuNinja: 100
            }
        }
    },
    {
        value: "waterShuriken",
        label: "Water Shuriken",
        element: "water",
        set: "waterRelease",
        stats: {
            A: {
                shuriken: 105,
                shurikenNinja: 50
            },
            S: {
                shuriken: 135,
                shurikenNinja: 80
            },
            SS: {
                shuriken: 180,
                shurikenNinja: 90
            }
        }
    },
    {
        value: "frozenFeather",
        label: "Frozen Feather",
        ninja: "Rin",
        set: "jadeFox",
        stats: {
            S: {
                atk: 102
            },
            SS: {
                atk: 195,
                hp: 30
            },
            R1: {
                atk: 245,
                hp: 35
            },
            R2: {
                atk: 305,
                hp: 40
            },
            R3: {
                atk: 370,
                hp: 45
            }
        }
    },
    {
        value: "iceFoxPendant",
        label: "Ice Fox Pendant",
        ninja: "Rin",
        set: "jadeFox",
        stats: {
            S: {
                ninjutsu: 56,
                hpRecovery: 1,
                rinAtk: 70
            },
            SS: {
                ninjutsu: 111,
                hpRecovery: 2,
                rinAtk: 105
            },
            R1: {
                ninjutsu: 132,
                hpRecovery: 2,
                rinAtk: 144
            },
            R2: {
                ninjutsu: 158,
                hpRecovery: 2,
                rinAtk: 204
            },
            R3: {
                ninjutsu: 200,
                hpRecovery: 3,
                rinAtk: 275
            }
        }
    },
    {
        value: "iceSpiritMirror",
        label: "Ice Spirit Mirror",
        ninja: "Rin",
        set: "jadeFox",
        stats: {
            S: {
                water: 77,
                boss: -4
            },
            SS: {
                water: 155,
                boss: -6
            },
            R1: {
                water: 180,
                boss: -7
            },
            R2: {
                water: 205,
                boss: -8
            },
            R3: {
                water: 242,
                boss: -9
            }
        }
    },
    {
        value: "foldingFan",
        label: "Jade Fox Folding Fan",
        ninja: "Rin",
        set: "jadeFox",
        stats: {
            S: {
                atk: 70,
                score: 20
            },
            SS: {
                atk: 135,
                score: 25
            },
            R1: {
                atk: 155,
                score: 30
            },
            R2: {
                atk: 180,
                score: 35
            },
            R3: {
                atk: 219,
                score: 40
            }
        }
    },
    {
        value: "azureDivineBell",
        label: "Azure Divine Bell",
        ninja: "Rin",
        set: "jadeFox",
        stats: {
            S: {
                hp: 27,
                score: 24
            },
            SS: {
                hp: 40,
                score: 45
            },
            R1: {
                hp: 50,
                score: 54
            },
            R2: {
                hp: 62,
                score: 70
            },
            R3: {
                hp: 70,
                score: 88
            }
        }
    },
    {
        value: "windRing",
        label: "Wind Ring",
        element: "wind",
        set: "windRelease",
        stats: {
            A: {
                ninjutsu: 100,
                ninjutsuNinja: 50
            },
            S: {
                ninjutsu: 175,
                ninjutsuNinja: 75
            },
            SS: {
                ninjutsu: 250,
                ninjutsuNinja: 100
            }
        }
    },
    {
        value: "windShuriken",
        label: "Wind Shuriken",
        element: "wind",
        set: "windRelease",
        stats: {
            A: {
                shuriken: 105,
                shurikenNinja: 50
            },
            S: {
                shuriken: 135,
                shurikenNinja: 80
            },
            SS: {
                shuriken: 180,
                shurikenNinja: 90
            }
        }
    },
    {
        value: "kamaitachiContract",
        label: "Kamaitachi Contract",
        ninja: "Souga",
        set: "tengu",
        stats: {
            S: {
                atk: 70,
                ninjutsu: 52,
                minionAndBoss: -3
            },
            SS: {
                atk: 109,
                ninjutsu: 74,
                minionAndBoss: -5
            },
            R1: {
                atk: 147,
                ninjutsu: 105,
                minionAndBoss: -6
            },
            R2: {
                atk: 213,
                ninjutsu: 143,
                minionAndBoss: -7
            },
            R3: {
                atk: 280,
                ninjutsu: 200,
                minionAndBoss: -8
            }
        }
    },
    {
        value: "eagleClawBoots",
        label: "Eagle Claw Boots",
        ninja: "Souga",
        set: "tengu",
        stats: {
            S: {
                atk: 70,
                hp: 27
            },
            SS: {
                atk: 130,
                hp: 40
            },
            R1: {
                atk: 155,
                hp: 50
            },
            R2: {
                atk: 180,
                hp: 62
            },
            R3: {
                atk: 219,
                hp: 70
            }
        }
    },
    {
        value: "paleMemories",
        label: "Pale Memories",
        ninja: "Souga",
        set: "tengu",
        stats: {
            S: {
                wind: 60,
                boss: -5
            },
            SS: {
                wind: 138,
                boss: -7
            },
            R1: {
                wind: 163,
                boss: -8
            },
            R2: {
                wind: 188,
                boss: -9
            },
            R3: {
                wind: 225,
                boss: -10
            }
        }
    },
    {
        value: "tengusFang",
        label: "Tengu's Fang",
        ninja: "Souga",
        set: "tengu",
        stats: {
            S: {
                score: 24,
                weapon: 126
            },
            SS: {
                score: 45,
                weapon: 175
            },
            R1: {
                score: 54,
                weapon: 235
            },
            R2: {
                score: 70,
                weapon: 299
            },
            R3: {
                score: 88,
                weapon: 365
            }
        }
    },
    {
        value: "tenguMask",
        label: "Tengu Mask",
        ninja: "Souga",
        set: "tengu",
        stats: {
            S: {
                score: 24,
                oni: 99
            },
            SS: {
                score: 35,
                oni: 188
            },
            R1: {
                score: 45,
                oni: 220
            },
            R2: {
                score: 55,
                oni: 260
            },
            R3: {
                score: 65,
                oni: 301
            }
        }
    },
    {
        value: "sevenFlameRosary",
        label: "Seven Flame Rosary",
        ninja: "Pepper",
        set: "redFlame",
        stats: {
            S: {
                fireSouls: 1
            },
            SS: {
                fireSouls: 2
            },
            R1: {
                fireSouls: 2,
                hp: 20
            },
            R2: {
                fireSouls: 2,
                hp: 42
            },
            R3: {
                fireSouls: 3,
                hp: 42
            }
        }
    },
    {
        value: "phoenixJadePendant",
        label: "Phoenix Jade Pendant",
        ninja: "Pepper",
        set: "redFlame",
        stats: {
            S: {
                atk: 75,
                hpRecovery: 1
            },
            SS: {
                atk: 135,
                hpRecovery: 1
            },
            R1: {
                atk: 165,
                hpRecovery: 2
            },
            R2: {
                atk: 200,
                hpRecovery: 2
            },
            R3: {
                atk: 240,
                hpRecovery: 3
            }
        }
    },
    {
        value: "redLotusCrystal",
        label: "Red Lotus Crystal",
        ninja: "Pepper",
        set: "redFlame",
        stats: {
            S: {
                hp: 30,
                fire: 70
            },
            SS: {
                hp: 45,
                fire: 140
            },
            R1: {
                hp: 54,
                fire: 172
            },
            R2: {
                hp: 64,
                fire: 198
            },
            R3: {
                hp: 75,
                fire: 220
            }
        }
    },
    {
        value: "dragonSpiritMask",
        label: "Dragon Spirit Mask",
        ninja: "Dragon Flame Kuro",
        set: "flameMaster",
        stats: {
            S: {
                fire: 96,
                boss: -4
            },
            SS: {
                fire: 144,
                boss: -6
            },
            R1: {
                fire: 176,
                boss: -7
            },
            R2: {
                fire: 207,
                boss: -8
            },
            R3: {
                fire: 241,
                boss: -9
            }
        }
    },
    {
        value: "fireRattle",
        label: "Fire Rattle",
        ninja: "Dragon Flame Kuro",
        set: "flameMaster",
        stats: {
            S: {
                hp: 30,
                atk: 71
            },
            SS: {
                hp: 42,
                atk: 131
            },
            R1: {
                hp: 58,
                atk: 161
            },
            R2: {
                hp: 64,
                atk: 181
            },
            R3: {
                hp: 70,
                atk: 222
            }
        }
    },
    {
        value: "mvpTrophy",
        label: "MVP Trophy",
        ninja: "Dragon Flame Kuro",
        set: "flameMaster",
        stats: {
            S: {
                soulOfFire: 1
            },
            SS: {
                soulOfFire: 2
            },
            R1: {
                soulOfFire: 2,
                atk: 83
            },
            R2: {
                soulOfFire: 3,
                atk: 112
            },
            R3: {
                soulOfFire: 3,
                atk: 129
            }
        }
    },
    {
        value: "mechanicalOwl",
        label: "Mechanical Owl",
        set: "silverMoon",
        ninja: "Moonlit Owl Yoru",
        stats: {
            S: {
                atk: 82,
                boss: -3
            },
            SS: {
                atk: 158,
                boss: -5
            },
            R1: {
                atk: 185,
                boss: -6
            },
            R2: {
                atk: 210,
                boss: -7
            },
            R3: {
                atk: 248,
                boss: -8
            }
        }
    },
    {
        value: "moonlitCalonyction",
        label: "Moonlit Calonyction",
        set: "silverMoon",
        ninja: "Moonlit Owl Yoru",
        stats: {
            S: {
                lightning: 99,
                hp: 26
            },
            SS: {
                lightning: 188,
                hp: 26
            },
            R1: {
                lightning: 227,
                hp: 26
            },
            R2: {
                lightning: 294,
                hp: 26
            },
            R3: {
                lightning: 358,
                hp: 26
            }
        }
    },
    {
        value: "moonGrainPot",
        label: "Moon Grain Pot",
        set: "silverMoon",
        ninja: "Moonlit Owl Yoru",
        stats: {
            S: {
                hpRecovery: 1,
                ninjutsu: 88
            },
            SS: {
                hpRecovery: 2,
                ninjutsu: 145
            },
            R1: {
                hpRecovery: 2,
                ninjutsu: 188
            },
            R2: {
                hpRecovery: 3,
                ninjutsu: 235
            },
            R3: {
                hpRecovery: 4,
                ninjutsu: 280
            }
        }
    },
    {
        value: "redemptiveEcho",
        label: "Redemptive Echo",
        set: "frostyMoon",
        ninja: "Snow Dance Rin",
        stats: {
            S: {
                atk: 60,
                hp: 32
            },
            SS: {
                atk: 90,
                hp: 44
            },
            R1: {
                atk: 110,
                hp: 50
            },
            R2: {
                atk: 129,
                hp: 56
            },
            R3: {
                atk: 150,
                hp: 64
            }
        }
    },
    {
        value: "frostMoonCase",
        label: "Frost Moon Case",
        set: "frostyMoon",
        ninja: "Snow Dance Rin",
        stats: {
            S: {
                water: 109
            },
            SS: {
                water: 163
            },
            R1: {
                water: 199
            },
            R2: {
                water: 233
            },
            R3: {
                water: 272
            }
        }
    },
    {
        value: "foxSpiritBell",
        label: "Fox Spirit Bell",
        set: "frostyMoon",
        ninja: "Snow Dance Rin",
        stats: {
            S: {
                atk: 114
            },
            SS: {
                atk: 133
            },
            R1: {
                atk: 152
            },
            R2: {
                atk: 171
            },
            R3: {
                atk: 190
            }
        }
    },
    {
        value: "blossomShuriken",
        label: "Blossom Shuriken",
        stats: {
            S: {
                blossom: 650,
                boss: -2
            },
            SS: {
                blossom: 890,
                boss: -2
            },
            R1: {
                blossom: 1084,
                boss: -2
            },
            R2: {
                blossom: 1282,
                boss: -2
            },
            R3: {
                blossom: 1482,
                boss: -2
            }
        },
        effects: [
            "Shuriken Orbs have a 50% chance to change into Blossom Shuriken"
        ]
    },
    {
        value: "devileyeRing",
        label: "Devileye Ring",
        stats: {
            S: {
                ninjutsu: 378,
                hp: 16,
                hpRecovery: -3
            },
            SS: {
                ninjutsu: 528,
                hp: 24,
                hpRecovery: -2
            },
            R1: {
                ninjutsu: 645,
                hp: 29,
                hpRecovery: -2
            },
            R2: {
                ninjutsu: 702,
                hp: 34,
                hpRecovery: -2
            },
            R3: {
                ninjutsu: 881,
                hp: 40,
                hpRecovery: -2
            }
        }
    },
    {
        value: "masterMystique",
        label: "Master Mystique",
        stats: {
            S: {
                ninjutsu: 90,
                ninjutsuEnery: 35
            },
            SS: {
                ninjutsu: 105,
                ninjutsuEnery: 45
            },
            R1: {
                ninjutsu: 120,
                ninjutsuEnery: 55
            },
            R2: {
                ninjutsu: 135,
                ninjutsuEnery: 65
            },
            R3: {
                ninjutsu: 150,
                ninjutsuEnery: 75
            }
        }
    },
    {
        value: "niohGauntlet",
        label: "Nioh Gauntlet",
        stats: {
            S: {
                atk: 165,
                minionAndBoss: 9
            },
            SS: {
                atk: 239,
                minionAndBoss: 12
            },
            R1: {
                atk: 291,
                minionAndBoss: 11
            },
            R2: {
                atk: 349,
                minionAndBoss: 10
            },
            R3: {
                atk: 409,
                minionAndBoss: 10
            }
        }
    },
    {
        value: "fourSymbols",
        label: "Four Symbols Amulet",
        stats: {
            S: {
                hp: 48,
                hpRecovery: 1
            },
            SS: {
                hp: 60,
                hpRecovery: 1
            },
            R1: {
                hp: 65,
                hpRecovery: 2
            },
            R2: {
                hp: 72,
                hpRecovery: 2
            },
            R3: {
                hp: 80,
                hpRecovery: 3
            }
        },
        effects: [
            "Gain a Spirit Shield that can resist DMG 2 times (take no effect in Story Mode)"
        ]
    },
    {
        value: "soulElixir",
        label: "Soul Elixir",
        stats: {
            S: {
                hpRecovery: 5
            },
            SS: {
                atk: 40,
                hpRecovery: 7
            },
            R1: {
                atk: 55,
                hpRecovery: 8
            },
            R2: {
                atk: 70,
                hpRecovery: 9
            },
            R3: {
                atk: 85,
                hpRecovery: 11
            }
        }
    },
    {
        value: "thunderDragonSheath",
        label: "Thunder Dragon Sheath",
        stats: {
            S: {
                weapon: 119,
                weaponCooldown: 5
            },
            SS: {
                weapon: 219,
                weaponCooldown: 7
            },
            R1: {
                weapon: 270,
                weaponCooldown: 8
            },
            R2: {
                weapon: 322,
                weaponCooldown: 9
            },
            R3: {
                weapon: 399,
                weaponCooldown: 10
            }
        }
    },
    {
        value: "specterSteelTrap",
        label: "Specter Steel Trap",
        stats: {
            S: {
                atk: 128,
                hpRecovery: -4,
                beast: 74
            },
            SS: {
                atk: 190,
                hpRecovery: -3,
                beast: 103
            },
            R1: {
                atk: 231,
                hpRecovery: -3,
                beast: 124
            },
            R2: {
                atk: 278,
                hpRecovery: -2,
                beast: 145
            },
            R3: {
                atk: 331,
                hpRecovery: -2,
                beast: 171
            }
        }
    },
    {
        value: "darumaOni",
        label: "Daruma Oni",
        stats: {
            S: {
                oni: 265,
                hpPercent: -9
            },
            SS: {
                oni: 339,
                hpPercent: -12
            },
            R1: {
                oni: 391,
                hpPercent: -11
            },
            R2: {
                oni: 449,
                hpPercent: -10
            },
            R3: {
                oni: 509,
                hpPercent: -10
            }
        }
    },
    {
        value: "darumaPrincess",
        label: "Daruma Princess",
        stats: {
            S: {
                humans: 265,
                hpPercent: -9
            },
            SS: {
                humans: 339,
                hpPercent: -12
            },
            R1: {
                humans: 391,
                hpPercent: -11
            },
            R2: {
                humans: 449,
                hpPercent: -10
            },
            R3: {
                humans: 509,
                hpPercent: -10
            }
        }
    },
    {
        value: "steamTechnician",
        label: "Land of Steam Technician",
        stats: {
            S: {
                mecha: 201,
                mechaReduce: -8
            },
            SS: {
                mecha: 275,
                mechaReduce: -10
            },
            R1: {
                mecha: 326,
                mechaReduce: -11
            },
            R2: {
                mecha: 385,
                mechaReduce: -12
            },
            R3: {
                mecha: 445,
                mechaReduce: -13
            }
        }
    },
    {
        value: "flameScroll",
        label: "Flame Scroll",
        stats: {
            SS: {
            },
            R1: {
                fire: 65
            },
            R2: {
                fire: 130
            },
            R3: {
                fire: 195
            }
        },
        effects: [
            "Receive a Flame Scroll when entering the battlefield. Cast Firebolt when triggered (a Ninja can only trigger Scroll Skills once in a battle; takes no effect in Story Mode)."
        ]
    },
    {
        value: "thunderbirdScroll",
        label: "Thunderbird Scroll",
        stats: {
            SS: {
            },
            R1: {
                lightning: 65
            },
            R2: {
                lightning: 130
            },
            R3: {
                lightning: 195
            }
        },
        effects: [
            "Receive a Thunder Bird Scroll when entering the battlefield. Cast Lightning Owls when triggered (a Ninja can only trigger Scroll Skills once in a battle; takes no effect in Story Mode)."
        ]
    },
    {
        value: "iceScroll",
        label: "Ice Scroll",
        stats: {
            SS: {
            },
            R1: {
                water: 65
            },
            R2: {
                water: 130
            },
            R3: {
                water: 195
            }
        },
        effects: [
            "Receive an Ice Scroll when entering the battlefield. Cast Blizzard when triggered (a Ninja can only trigger Scroll Skills once in a battle; takes no effect in Story Mode)."
        ]
    },
    {
        value: "windBladeScroll",
        label: "Wind Blade Scroll",
        stats: {
            SS: {
            },
            R1: {
                wind: 65
            },
            R2: {
                wind: 130
            },
            R3: {
                wind: 195
            }
        },
        effects: [
            "Receive a Wind Blade Scroll when entering the battlefield. Cast Wind Blade when triggered (a Ninja can only trigger Scroll Skills once in a battle; takes no effect in Story Mode)."
        ]
    },
    {
        value: "flameSoulFlag",
        label: "Flame Soul Flag",
        stats: {
            SS: {
                hp: 42,
                score: 48
            },
            R1: {
                hp: 54,
                score: 60
            },
            R2: {
                hp: 66,
                score: 80
            },
            R3: {
                hp: 80,
                score: 100
            }
        }
    },
    {
        value: "acalaArmor",
        label: "Acala Armor",
        stats: {
            SS: {
                minionAndBoss: -7,
                hp: 42
            },
            R1: {
                minionAndBoss: -8,
                hp: 54
            },
            R2: {
                minionAndBoss: -9,
                hp: 66
            },
            R3: {
                minionAndBoss: -11,
                hp: 80
            }
        }
    },
    {
        value: "oniIndex",
        label: "Oni Index",
        stats: {
            SS: {
                score: 45,
                atk: 86
            },
            R1: {
                score: 55,
                atk: 99
            },
            R2: {
                score: 70,
                atk: 120
            },
            R3: {
                score: 85,
                atk: 144
            }
        }
    },
    {
        value: "thunderDragonOrb",
        label: "Thunder Dragon Orb",
        stats: {
            S: {
                atk: 77,
                hp: 30
            }
        }
    },
    {
        value: "darumaPanda",
        label: "Daruma Panda",
        stats: {
            S: {
                score: 20,
                hp: 50
            }
        }
    },
    {
        value: "steelGauntlet",
        label: "Steel Gauntlet",
        stats: {
            A: {
                minionAndBoss: -2,
                hp: 20
            }
        }
    },
    {
        value: "darumaKind",
        label: "Daruma - Kind",
        set: "daruma",
        stats: {
            A: {
                hp: 35
            }
        }
    },
    {
        value: "darumaEvil",
        label: "Daruma - Evil",
        set: "daruma",
        stats: {
            A: {
                atk: 58
            }
        }
    },
    {
        value: "furinkazanFlag",
        label: "Furinkazan Flag",
        stats: {
            A: {
                score: 26
            },
            S: {
                score: 42
            }
        }
    },
    {
        value: "novaTaiko",
        label: "Nova Taiko",
        stats: {
            A: {
                atk: 80
            },
            S: {
                atk: 119
            }
        }
    },
    {
        value: "colorfulHyorogan",
        label: "Colorful Hyorogan",
        stats: {
            A: {
                hp: 45
            },
            S: {
                hp: 70
            }
        }
    },
    {
        value: "stealthSuit",
        label: "Silver Owl Stealth Suit",
        stats: {
            A: {
                hp: 20,
                minion: 4
            },
            S: {
                hp: 33,
                minion: 6
            }
        }
    },
    {
        value: "dragonScaleArmor",
        label: "Dragon Scale Armor",
        stats: {
            A: {
                hp: 20,
                boss: 4
            },
            S: {
                hp: 33,
                boss: 6
            }
        }
    },
    {
        value: "demonHoundsTeeth",
        label: "Demon Hound's Teeth",
        stats: {
            A: {
                atk: 30,
                score: 18
            },
            S: {
                atk: 45,
                boss: 25
            }
        }
    },
    {
        value: "redFrogOil",
        label: "Red Frog Oil",
        stats: {
            A: {
                weapon: 181
            },
            S: {
                weapon: 323
            }
        }
    },
    {
        value: "regenerationHormone",
        label: "Regeneration Hormone",
        stats: {
            B: {
                hpRecovery: 2
            },
            A: {
                hpRecovery: 3
            }
        }
    },
    {
        value: "legendOfSwordMaster1",
        label: "The Legend of Sword Master - Part I",
        set: "sword",
        stats: {
            B: {
                weapon: 20,
                score: 10
            },
            A: {
                weapon: 50,
                score: 15
            }
        }
    },
    {
        value: "legendOfSwordMaster2",
        label: "The Legend of Sword Master - Part II",
        set: "sword",
        stats: {
            B: {
                weaponCooldown: -2
            },
            A: {
                weaponCooldown: -4
            }
        }
    },
    {
        value: "ninjutsuSecretScroll",
        label: "Ninjutsu Secret Scroll",
        stats: {
            B: {
                ninjutsu: 55
            },
            A: {
                ninjutsu: 80
            },
        }
    },
    {
        value: "envenomedShuriken",
        label: "Envenomed Shuriken",
        stats: {
            B: {
                shuriken: 135
            },
            A: {
                shuriken: 235
            }
        }
    },
    {
        value: "stealthSuit",
        label: "Stealth Suit",
        stats: {
            B: {
                minion: -4
            }
        }
    },
    {
        value: "tigerTeeth",
        label: "Tiger Teeth",
        stats: {
            C: {
                score: 8,
                atk: 12
            },
            B: {
                score: 12,
                atk: 15
            }
        }
    },
    {
        value: "hyorogan",
        label: "Hyorogan",
        stats: {
            C: {
                hp: 20
            },
            B: {
                hp: 25
            }
        }
    },
    {
        value: "ashigaruArmor",
        label: "Ashigaru Armor",
        stats: {
            C: {
                boss: -3
            },
            B: {
                weapon: -4
            }
        }
    },
    {
        value: "pungentSwordOil",
        label: "Pungent Sword Oil",
        stats: {
            C: {
                weapon: 75
            },
            B: {
                weapon: 119
            }
        }
    },
    {
        value: "courageTaiko",
        label: "Courage Taiko",
        stats: {
            C: {
                atk: 30
            },
            B: {
                atk: 48
            }
        }
    },
    {
        value: "nyantaWallet",
        label: "Nyanta Wallet",
        stats: {
            C: {
                coin: 8
            },
            B: {
                coin: 11
            }
        }
    },
    {
        value: "ninjutsuCheatSheet",
        label: "Ninjutsu Cheat Sheet",
        stats: {
            C: {
                ninjutsuEnery: 15
            },
            B: {
                ninjutsuEnery: 15
            }
        }
    },
    {
        value: "Flag",
        label: "Flag",
        stats: {
            C: {
                score: 12
            },
            B: {
                score: 17
            }
        }
    },
    {
        value: "steelShuriken",
        label: "Steel Shuriken",
        stats: {
            D: {
                shuriken: 40
            },
            C: {
                shuriken: 75
            }
        }
    },
    {
        value: "ninjutsuShatteredScroll",
        label: "Ninjutsu Shattered Scroll",
        stats: {
            D: {
                ninjutsu: 25
            },
            C: {
                ninjutsu: 35
            }
        }
    },
    {
        value: "brokenFlag",
        label: "Broken Flag",
        stats: {
            D: {
                score: 9,
                hp: -2
            }
        }
    },
    {
        value: "rattleDrum",
        label: "Rattle Drum",
        stats: {
            D: {
                atk: 12
            }
        }
    },
    {
        value: "spoiledHyorogan",
        label: "Spoiled Hyorogan",
        stats: {
            D: {
                hp: 14,
                atk: -4
            }
        }
    },
    {
        value: "swordOil",
        label: "Sword Oil",
        stats: {
            D: {
                weapon: 42
            }
        }
    },
    {
        value: "counterfeitWallet",
        label: "Counterfeit Wallet",
        stats: {
            D: {
                coin: 5
            }
        }
    }
];